module.exports = __webpack_public_path__ + "media/assets/icons/plus-clock-61996318f7e902b30a7502fdbbccc582.svg";